import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import Routes from './routes'

Vue.config.productionTip = false

import { library } from '@fortawesome/fontawesome-svg-core'
import { faStar, faPlay, faAngleDown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faStar, faPlay, faAngleDown);

Vue.component('font-awesome-icon', FontAwesomeIcon);

// css
import './assets/css/style.css'

// Router
Vue.use(VueRouter);
const router = new VueRouter({
  routes: Routes,
  mode: 'history'
});

new Vue({
  render: h => h(App),
  router: router
}).$mount('#app')
